export default __webpack_public_path__ + "static/media/27.5e45ded2.jpg";